import React from 'react';
import { useUserOptionSearch } from '../use-user-option-search';
import { AsyncMultiSelect, AsyncMultiSelectImplementationProps } from './async-multi-select';

type UserMultiSelectProps = Omit<AsyncMultiSelectImplementationProps, 'minimumQueryLength'>;

export const UserMultiSelect = React.forwardRef<HTMLDivElement, UserMultiSelectProps>(
    function UserMultiSelect(props: UserMultiSelectProps, ref): React.ReactElement {
        const { searchUserOptions } = useUserOptionSearch({ includeDisabled: true });
        return <AsyncMultiSelect {...props} ref={ref} getOptions={searchUserOptions} />;
    }
);
